"use strict"

import React from "react"
import {observer} from "mobx-react"
import ReactTooltip from "react-tooltip"
import MobxReactForm from "mobx-react-form"
import {FormattedMessage, injectIntl} from "react-intl"
import validatorjs from "validatorjs"
import Moment from "moment"
import XsDateTimePicker from "../../../../../global/ui/xsDateTimePicker/xsDateTimePicker"
import XsIconButton from "../../../../../global/ui/xsButton/xsIconButton"
import XsTable from "../../../../../global/ui/xsTable/xsTable"
import XsButton from "../../../../../global/ui/xsButton/xsButton"
import SearchSelect from "../../../../../global/ui/xsSearchSelect/xsSearchSelect"
import XsConfirmationDialog from "../../../../../global/ui/xsDialog/xsConfirmationDialog"
import bindings from "../../../../../global/ui/globalUISchemeBindings"
import dataBindings from "./capitationBindings"
import {
	loadDataToFormByScheme,
	saveFormDataByScheme,
	insertFormDataByScheme,
	deleteDataByScheme,
	resetForm
} from "../../../../../global/helpers/bindings"
import Grid from "@material-ui/core/Grid"
import SaveIcon from "@material-ui/icons/Done"
import CancelIcon from "@material-ui/icons/Clear"
import fields from "./capitationFields"
import DataStore from "../../../stores/DataStore"
import WarningStore from "../../../../../global/store/WarningStore"
import GlobalStore from "../../../../../global/store/GlobalStore"
import CapitationFormStore from "../../../stores/CapitationFormStore"
import PatientInfoFormStore from "../../../stores/PatientInfoFormStore"
import {getSelectedOrgUnitID, getUserPersonnelID} from "../../../../../global/helpers/actions"

@injectIntl
@observer
export default class CapitationTableEx extends React.Component {
	constructor(props) {
		super(props)

		const hooks = {
			onSubmit(/*form*/) {
				// special validation here
			},
			onSuccess(form) {
				if (CapitationFormStore.editable) {
					saveFormDataByScheme(
						form,
						dataBindings,
						{},
						() => DataStore.getPatientCapitations(),
						false,
						"Patient.form.capitationForm.editSuccess"
					)
					CapitationFormStore.editable = false
				} else {
					insertFormDataByScheme(
						form,
						dataBindings,
						{
							personnelId: getUserPersonnelID(),
							patientId: DataStore.patientDTO.get("patientID"),
							providerId: getSelectedOrgUnitID()
						},
						() => DataStore.getPatientCapitations(),
						false,
						"Patient.form.capitationForm.savesuccess"
					)
					// saveFormDataByScheme(form, dataBindings, { personnelId: getUserPersonnelID(), patientId: DataStore.patientDTO.get("patientID"), providerId: getSelectedOrgUnitID() }, () => DataStore.getPatientCapitations(), false, "Patient.form.capitationForm.savesuccess")
				}

				form.reset()
				CapitationFormStore.isAdd = false
			},
			onError() {}
		}

		this.form = new MobxReactForm(fields.load(), {plugins: {dvr: validatorjs}, hooks, bindings})

		this.initForm()
	}

	form

	initForm() {
		resetForm(this.form, dataBindings)
	}

	onHandleRowClick = (dataRow) => {
		// logger("end_reason: ", this.form.$("end_reason").value)
		// this.form.$("end_reason").set("value", this.form.$("end_reason").value._id)
		// this.form.set("end_reason", this.form.$("end_reason").value._id)
		loadDataToFormByScheme(this.form, dataBindings, {capitationId: dataRow.delete})

		CapitationFormStore.editable = true
		CapitationFormStore.isAdd = true
	}

	deleteCapitation = () => {
		deleteDataByScheme(
			dataBindings,
			GlobalStore.confirmationDialogParams.capitationId,
			() => DataStore.getPatientCapitations(),
			"Patient.form.capitationForm.deleteMessage"
		)
		CapitationFormStore.editable = false
		this.initForm()
	}

	render() {
		return (
			<div className="xs-capitation-table-ex">
				<div className="xs-table">
					<XsTable
						config={{
							columnDefs: {
								from: {
									title: <FormattedMessage id="Capitation.List.From" />,
									type: "datetime",
									design: {
										width: "150px",
										body: {
											formatter: (props) => {
												return isSafe(props) && isNotEmpty(props) ? Moment(props).format("DD.MM.YYYY") : ""
											}
										}
									},
									sortable: true
								},
								to: {
									title: <FormattedMessage id="Capitation.List.To" />,
									type: "datetime",
									design: {
										width: "150px",
										body: {
											formatter: (props) => {
												return isSafe(props) && isNotEmpty(props) ? Moment(props).format("DD.MM.YYYY") : ""
											}
										}
									},
									sortable: true
								},
								end_reason: {
									title: <FormattedMessage id="Capitation.List.EndReason" />,
									type: "string",
									design: {
										width: "200px"
									}
								},
								provider_id: {
									title: <FormattedMessage id="Capitation.List.ProviderId" />,
									type: "string",
									design: {
										width: "175px"
									}
								},
								doctor_code: {
									title: <FormattedMessage id="Calendar.overPrescription.dialog.doctorCode" />,
									type: "string"
								},
								delete: {
									title: "",
									type: "action",
									design: {
										width: "5%",
										body: {
											renderer: (props) => {
												return (
													<XsIconButton
														className="action-delete"
														icon={
															<span>
																<i
																	className="fal fa-trash-alt fa-lg xs-greyDefault"
																	data-tip
																	data-for="removeCapitation"
																/>
																<ReactTooltip id="removeCapitation" effect="solid">
																	<FormattedMessage id="Common.label.removeCapitation" />
																</ReactTooltip>
															</span>
														}
														onClick={() =>
															GlobalStore.openConfirmationDialog("xsDeletePatientCapitation", {
																capitationId: props.value
															})
														}
													/>
												)
											}
										}
									}
								}
							},
							options: {
								hidePager: true,
								showCursor: true,
								onRowClick: (dataRow) => {
									this.onHandleRowClick(dataRow)
								},
								mapper: (dataRow) => {
									let orgUnit = GlobalStore.orgunits.find((x) => x._id === dataRow.provider_id)
									return {
										from: dataRow.from,
										to: dataRow.to,
										end_reason: isSafe(dataRow.end_reason) ? dataRow.end_reason.name_ext : "",
										provider_id: isSafe(orgUnit) ? orgUnit.provider_code : "",
										doctor_code: isSafe(orgUnit) ? orgUnit.doctor_code : "",
										delete: dataRow.capitation_id
									}
								}
							},
							dataSource: DataStore.patientDTO.get("capitations")
						}}
					/>
				</div>
				<div className="xs-form">
					{CapitationFormStore.isAdd ? (
						<form>
							<Grid container direction="row" spacing={8}>
								<Grid item xs={3}>
									<XsDateTimePicker field={this.form.$("from")} showTimeSelect={false} />
								</Grid>
								<Grid item xs={3}>
									<XsDateTimePicker field={this.form.$("to")} showTimeSelect={false} />
								</Grid>
								<Grid item xs={3}>
									<SearchSelect
										field={this.form.$("end_reason")}
										items={GlobalStore.CL["endReason"]}
										onChange={(val) => {
											if (val == "D" && isEmpty(PatientInfoFormStore.formRef.$("deathDate").value)) {
												WarningStore.open(this.props.intl.formatMessage({id: "Common.label.fillDeathDateInPersonData"}))
											}
										}}
										menuPlacement="top"
									/>
								</Grid>
								{/* <Grid item xs={3}><XsInput white={true} field={this.form.$("end_reason")} /></Grid> */}
								<Grid item xs={3} className="xs-form-actions">
									{CapitationFormStore.editable ? (
										<XsButton
											className="xs-success mr-3"
											type="submit"
											onClick={this.form.onSubmit}
											text={<FormattedMessage id="Common.label.save" />}
											icon={<SaveIcon />}
										/>
									) : (
										<XsButton
											className="xs-success mr-3"
											type="submit"
											onClick={this.form.onSubmit}
											text={<FormattedMessage id="Common.label.add" />}
											icon={<SaveIcon />}
										/>
									)}
									<XsButton
										className="xs-default xs-outline"
										onClick={() => {
											this.initForm()
											CapitationFormStore.isAdd = false
											CapitationFormStore.editable = false
										}}
										text={<FormattedMessage id="Common.label.cancel" />}
										icon={<CancelIcon />}
									/>
								</Grid>
							</Grid>
						</form>
					) : (
						<XsButton
							className="xs-default xs-outline xs-addAnother"
							icon={<i className="fal fa-plus-circle" />}
							text={<FormattedMessage id="Common.button.addAnother" />}
							onClick={() => {
								if (!GlobalStore.allowOrgUnitExpertiesCodeExt.includes(GlobalStore.orgunitExpertiseCodeExt)) {
									GlobalStore.openConfirmationDialog("xsOrgunitCodeExt")
								} else {
									CapitationFormStore.isAdd = true
									CapitationFormStore.editable = false
									this.initForm()
								}
							}}
						/>
					)}
				</div>
				<XsConfirmationDialog
					type="warning"
					name="xsOrgunitCodeExt"
					text={<FormattedMessage id="Common.label.OrgunitNotAllowCreateCapitationDoYouWantContinue" />}
					headerConfig={{
						text: "Common.label.warning",
						icon: <i className="fal fa-trash-alt fa-2x" />
					}}
					cancelBtn={{
						icon: <i className="fal fa-times fa-lg" />,
						text: "Common.label.noContinue"
					}}
					confirmBtn={{
						icon: <i className="fal fa-trash-alt fa-lg" />,
						text: "Common.label.yesContinue"
					}}
					onConfirmation={() => {
						CapitationFormStore.isAdd = true
						CapitationFormStore.editable = false
						this.initForm()
					}}
				/>
				<XsConfirmationDialog
					type="danger"
					name="xsDeletePatientCapitation"
					text={<FormattedMessage id="Patient.form.capitationForm.confirmationMessage" />}
					headerConfig={{
						text: "Common.label.warning",
						icon: <i className="fal fa-trash-alt fa-2x" />
					}}
					cancelBtn={{
						icon: <i className="fal fa-times fa-lg" />,
						text: "Common.btn.not.delete"
					}}
					confirmBtn={{
						icon: <i className="fal fa-trash-alt fa-lg" />,
						text: "Common.btn.capitation.delete"
					}}
					onConfirmation={() => this.deleteCapitation()}
				/>
			</div>
		)
	}
}
